import type {
  GetTemplateByIdRequestBody,
  Template,
} from "@/common/types/templates";

import { useEffect, useState } from "react";

import { getCustomTemplateById as getCustomTemplateByIdService } from "@/services/templates";

export const useTemplateById = (
  id: number | string
): {
  result: Template | null;
  loading: boolean;
  error: boolean;
} => {
  const [result, setResult] = useState<Template | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const getTemplateById = async (
    body: GetTemplateByIdRequestBody
  ): Promise<void> => {
    setLoading(true);
    setError(false);
    setResult(null);

    try {
      const template = await getCustomTemplateByIdService(body);

      setResult(template);
      setLoading(false);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      setError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    void getTemplateById({ id: Number(id) });
  }, [id]);

  return { result, loading, error };
};
